import { HttpParams } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { ApiCallingService } from "../../services/api-calling.service";
import { ConfigApi } from "../../config-api";
import { Globals } from "../../common/global";

@Component({
  selector: "app-sharekayak-term",
  templateUrl: "./sharekayak-term.component.html",
  styleUrls: ["./sharekayak-term.component.css"],
})
export class SharekayakTermComponent implements OnInit {
  sharekayakData: any;
  hasDefaultSharekayak = false;
  userId = "";
  constructor(
    private toastr: ToastrService,
    private apiCallingService: ApiCallingService,
    public Globals: Globals
  ) {
    this.userId = this.Globals.getUser()._id;
  }

  ngOnInit(): void {
    this.getTerms();
  }
  getTerms() {
    this.apiCallingService
      .callAPI(
        {},
        "GET",
        ConfigApi.URLS.WAIVER.GET_WAIVER +
          "?user_id=" +
          this.userId +
          "&brand=Sharekayak"
      )
      .subscribe((res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          var data = res.data;

          if (data.waiverTerm) {
            this.sharekayakData = data.waiverTerm;
            this.hasDefaultSharekayak = false;
          } else {
            this.sharekayakData = data.defaultWaiverTerm;
            this.hasDefaultSharekayak = true;
          }
        }
      });
  }

  updateTerms(data: any) {
    if (!this.hasDefaultSharekayak) {
      const body = new HttpParams()
        .set("terms", data.content)
        .set("brand_name", this.sharekayakData.brand_name)
        .set("title", data.titlename);
      this.apiCallingService
        .callAPI(
          body,
          "PUT",
          ConfigApi.URLS.WAIVER.UPDATE + "/" + this.sharekayakData._id
        )
        .subscribe((res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.toastr.success("Waiver updated successfully");
            this.getTerms();
          }
        });
    } else {
      const body = new HttpParams()
        .set("user_id", this.userId)
        .set("terms", data.content)
        .set("brand_name", this.sharekayakData.brand_name)
        .set("title", data.titlename);
      this.apiCallingService
        .callAPI(body, "POST", ConfigApi.URLS.WAIVER.ADD)
        .subscribe((res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.toastr.success("Waiver updated successfully");
            this.getTerms();
          }
        });
    }
  }
}
